import { UserAuth } from 'entities/user/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

type RequestBody = {
  address: {
    city?: string,
    country?: number,
    line1?: string,
    line2?: string,
    postalCode?: string
  },
  dateOfBirth: string,
  email: string,
  firstName: string,
  'g-recaptcha-response': string,
  gender: string,
  language: string,
  lastName: string,
  password: string,
  phone: string,
  phoneCountry: number,
  privacyPolicy: boolean,
  registrationSource?: string,
  termsAndConditions: boolean,
  utm: object;
}

type GetAddressResponse = {
  city: string;
  country: number;
  line1: string;
  line2?: string;
  postalCode: string;
}

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    createAccount: build.mutation<ApiResponse<UserAuth>, Partial<RequestBody>>({
      query: (body) => {
        return {
          url: '/apply/private',
          method: 'POST',
          body,
        };
      },
    }),
  })
})

export const { useCreateAccountMutation } = _api; 